/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect } from "react";
import { CloseIcon } from "../../../components/Icons";
import { StyledBookAVisitButton } from "../../../components/LayoutApp/LayoutApp.style";
import { useModal } from "../../../context/ModalContext";
import { MODALS } from "../../../config/params";
import { useRetirePet } from "../../../services/retire-pet/retire-pet.service";
import { PAGES_PATH } from "../../../navigation/params";
import { useNavigate } from "react-router-dom";
import { useRetirePetStore } from "../../../hooks/redux-hooks/pet-retire-store/pet-retire-store";
import { toastMessageActions } from "../../../state/request";
import { useDispatch } from "react-redux";
import { getUnixTimestamp } from "../../../utils";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { userActivityLogger } from "../../../utils/mixpanel";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";

const ConfirmClosureModal = () => {
  const { closeModal, openModal } = useModal();
  const { updateRetirePet, petDeleted } = useRetirePet();
  const navigate=useNavigate();
  const dispatch = useDispatch();
  const { petName, petId, retireReason, reasonDescription, setDeletedStatus } = useRetirePetStore();
  const { setSelectedPets }=useAppointmentStore();
  const { clearPetInfoMap } = usePetStore();

  const handleConfirmClick = () => {
    userActivityLogger(MIXPANEL_EVENTS.RETIRE_PET_PROFILE_TRIGGERED,
      {
        pet_name: petName,
      });
    updateRetirePet({
      isDead: retireReason=="Deceased"?true:false,
      petId: petId,
      dateOfDeath: getUnixTimestamp(new Date()).toString(),
      reason:
    `${retireReason}${reasonDescription.length > 0 ? ` : ${reasonDescription}` : ""}`,
    });

    setSelectedPets([]);
  };

  const handleModalClose = () => {
    userActivityLogger(MIXPANEL_EVENTS.EXIT_RETIRE_PET_FLOW,
      {
        pet_name: petName,
        cancelled_page: "reason_review",
      });
    closeModal();
  };

  const handleEditClick = () => {
    userActivityLogger(MIXPANEL_EVENTS.EDIT_REASON_RETIRE_PET_PROFILE,
      {
        pet_name: petName,
      });
    openModal(MODALS.CLOSE_PET_MODAL);
  };

  useEffect(()=>{
    if (petDeleted?.deleted) {
      setDeletedStatus(true);
      clearPetInfoMap();
      userActivityLogger(MIXPANEL_EVENTS.RETIRE_PET_PROFILE_SUCCESS,
        {
          pet_name: petName,
        });
      dispatch(toastMessageActions.setGlobalAlert(
        { severity: "success", message: `${petName}’s profile has been removed`, customIcon: "info" }));
      navigate(`${PAGES_PATH.PET_CARE}`);
      closeModal();
    } else {
      userActivityLogger(MIXPANEL_EVENTS.RETIRE_PET_PROFILE_FAILURE,
        {
          pet_name: petName,
          error_message: petDeleted?.messages[0],
        });
    }
  }, [petDeleted]);


  return (
    <div className="h-full p-1">
      <div className="h-full flex flex-col items-center gap-6">
        <div onClick={handleModalClose} className="w-full flex justify-end cursor-pointer">
          <CloseIcon />
        </div>
        <div className="flex-1 flex flex-col gap-6 w-full">
          <div className="flex flex-col items-center">
            <div className="text-2xl font-semibold text-center">
              <div>Confirm Closure of</div>
              <div> {`${petName}'s Profile`}</div>
            </div>
            <div className="text-base px-2 text-center">
              {`${petName}’s profile will be removed from active care. This action cannot be undone. `}
            You’ll still be able to access their profile in &apos;Past Pets&apos; from your Account.
            </div>
          </div>
          <div className="flex-1">
            <div className="bg-white md:max-h-64 2xl:max-h-96 overflow-y-scroll scroll-hide
            border border-gray-3 p-4 rounded-lg flex flex-col gap-2.5">
              <div className="text-sm flex flex-col gap-2.5">
                <div className="font-semibold">Selected reason</div>
                <div>
                  {`${retireReason} ${reasonDescription.length > 0 ? `: ${reasonDescription}` : ""}`}
                </div>
                <div>
                  <StyledBookAVisitButton
                    isOpenSidebar={true}
                    size="small"
                    disabled={false}
                    onClick={handleEditClick}
                    className="!m-0 w-full !text-sm !border !border-gray-1 !bg-white hover:!text-black"
                  >
                    Edit Reason
                  </StyledBookAVisitButton>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="w-full !sticky bottom-0 flex flex-col gap-2">
          <StyledBookAVisitButton
            isOpenSidebar={true}
            color="primary"
            size="small"
            disabled={false}
            onClick={handleConfirmClick}
            className="!m-0 w-full !text-sm"
          >
            Confirm
          </StyledBookAVisitButton>
          <StyledBookAVisitButton
            isOpenSidebar={true}
            size="small"
            disabled={false}
            onClick={handleModalClose}
            className="!m-0 w-full !text-sm !bg-taupe-2 hover:!text-black"
          >
            Cancel
          </StyledBookAVisitButton>
        </div>
      </div>
    </div>
  );
};

export default ConfirmClosureModal;
